// Providers
import { useProfilesStore } from '@/utils/zustand/providers/profiles-provider';

// Hooks
import useSocialProfiles from '@/utils/hooks/swr/useSocialProfiles';

// Components
import { MultiProfileItem } from '@/components/composite/SelectedProfiles/MultiSelectionProfiles/MultiProfileItem';
import { ProfilesList } from '@/components/composite/SelectedProfiles/ProfilesList';

// Types
import type { SelectedProfilesProps } from '@/components/composite/SelectedProfiles';
import useSPGroups from '@/utils/hooks/swr/group/useSPGroups';
import useActiveGroup from '@/utils/hooks/user/useActiveGroup';
import { GroupItem } from '@/components/composite/SelectedProfiles/MultiSelectionProfiles/GroupItem';

export function MultiSelectionProfiles({ itemsSize }: Required<SelectedProfilesProps>) {
    const { activatedSocialProfiles } = useSocialProfiles({ revalidateIfStale: false });
    const { activeSocialProfileId, activeMultiSelectionProfiles } = useProfilesStore(
        (state) => state
    );
    const { activeGroup } = useActiveGroup();
    const { activatedSpGroups } = useSPGroups({ revalidateIfStale: false });

    const profiles =
        activeGroup?.social_profiles.filter((profiles) => profiles.active) ??
        activeMultiSelectionProfiles?.socialProfileIds.map((profileId) => {
            return activatedSocialProfiles.find((profile) => profile.id === profileId);
        });

    const group =
        activeGroup ??
        activatedSpGroups.find((group) => {
            if (group.social_profiles.length !== profiles.length) {
                return false;
            }
            return profiles.every((profile) =>
                group.social_profiles.some((groupProfile) => groupProfile.id === profile.id)
            );
        });

    return (
        <div className="flex items-center gap-4">
            {group ? (
                <GroupItem itemsSize={itemsSize} group={group} isActive={!activeSocialProfileId} />
            ) : (
                <MultiProfileItem itemsSize={itemsSize} isActive={!activeSocialProfileId} />
            )}
            <span className="h-5 min-w-[2px] bg-icoGray-300 dark:bg-icoDarkMode-beton" />
            <ProfilesList itemsSize={itemsSize} profiles={profiles} />
        </div>
    );
}
